import React from 'react';
import '../styles/ScoreFilterControls.css';
import { useScoreFilters } from '../context/ScoreFiltersContext';
import { FiSearch } from 'react-icons/fi';
import { LuArrowUpDown } from 'react-icons/lu';
import useLocale from '../hooks/useLocale';

const FILTER_TEXT = {
  ja: {
    search: '検索',
    searchPlaceholder: '曲名・アーティスト・#タグで検索',
    sort: '並び替え',
    updatedDesc: '更新が新しい順',
    updatedAsc: '更新が古い順',
    artistAsc: 'アーティスト名順（A→Z）',
  },
  en: {
    search: 'Search',
    searchPlaceholder: 'Search title, artist or #tag',
    sort: 'Sort',
    updatedDesc: 'Recently updated',
    updatedAsc: 'Oldest updated',
    artistAsc: 'Artist (A→Z)',
  },
};

const ScoreFilterControls = () => {
  const { query, setQuery, sortKey, setSortKey } = useScoreFilters();
  const locale = useLocale();
  const text = FILTER_TEXT[locale] || FILTER_TEXT.en;

  return (
    <div className="score-filters">
      <div className="score-filter-field">
        <label htmlFor="score-search" className="score-filter-label">
          {text.search}
        </label>
        <div className="score-filter-control">
          <FiSearch className="score-filter-icon" aria-hidden="true" />
          <input
            id="score-search"
            type="text"
            placeholder={text.searchPlaceholder}
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            className="score-filter-input"
          />
        </div>
      </div>
      <div className="score-filter-field">
        <label htmlFor="score-sort" className="score-filter-label">
          {text.sort}
        </label>
        <div className="score-filter-control score-filter-control--select">
          <LuArrowUpDown className="score-filter-icon" aria-hidden="true" />
          <select
            id="score-sort"
            value={sortKey}
            onChange={(e) => setSortKey(e.target.value)}
            className="score-filter-select"
          >
            <option value="updated-desc">{text.updatedDesc}</option>
            <option value="updated-asc">{text.updatedAsc}</option>
            <option value="artist-asc">{text.artistAsc}</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default ScoreFilterControls;
